/**
 * replace text with mapping link data
 * __LINK\d__ 를 a 태그로 매핑하여 반환
 * @param text {string}
 * @param linkObj {*}
 * @returns string
 */
export const getTextLinks = (text = '', linkObj = {}) => {
  if (!text || !linkObj) {
    return ''
  }
  const LINK_REG_EXP = /LINK\d__(.*?)__/gi
  const hasLink = text.match(LINK_REG_EXP)

  if (!hasLink) {
    return text
  }

  return text.replace(LINK_REG_EXP, (_, linkText) => {
    const [matchedLink] = hasLink[0].match(/LINK\d/gi)
    const linkData = linkObj[`${matchedLink}`]

    const href = linkData?.href
    const attrs = linkData?.attr
      ? Object.entries(linkData.attr)
          .map(([key, value]) => ` ${key}="${value}"`)
          .join('')
      : ''

    return `<a href="${href}"${attrs} class="noti-more">${linkText}</a>`
  })
}
